<template>
  <table class="table is-bordered is-fullwidth ">
    <tbody>
      <template v-for="row in flattenedRows">
        <tr :key="row.permission.permissionRecordID"
          :class="{ 'access-parent-row': row.level === 0, [`theme-${$theme.name}`]: row.level === 0 }">
          <td :style="row.level > 0 ? { paddingLeft: `${row.level * 24}px` } : {}">{{ row.permission.name }}</td>
          <td class="has-text-centered">
            <div class="pretty p-icon p-curve p-smooth p-bigger m-0">
              <input type="checkbox"
                v-model="row.permission.active"
                @change="handleToggle(row.permission, row.level)"
                :disabled="row.permission.disabled">
              <div class="state p-primary">
                <span class="icon mso mso-24px">check</span>
                <label />
              </div>
            </div>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import _cloneDeep from 'lodash/cloneDeep'
import Guid from '../../../components/Guid'

export default {
  name: 'PermissionTree',
  props: {
    permissionRecords: {
      type: Array,
      required: true
    },
    disableToggleChildren: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerPermissionRecords: []
    }
  },
  computed: {
    categories() {
      if (!Array.isArray(this.innerPermissionRecords) || this.innerPermissionRecords.length === 0) {
        return []
      }

      const map = {}
      const roots = []

      this.innerPermissionRecords.forEach((rec) => {
        map[rec.permissionRecordID] = rec
      })
      this.innerPermissionRecords.forEach((rec) => {
        if (!rec.hasOwnProperty('children')) {
          this.$set(rec, 'children', [])
        } else {
          rec.children = []
        }
      })

      this.innerPermissionRecords.forEach((rec) => {
        if (rec.treeLevel === 0 || rec.parentID === Guid.empty()) {
          roots.push(map[rec.permissionRecordID])
        } else if ((rec.treeLevel === -1 || rec.treeLevel === 1 || rec.treeLevel === 2) && map[rec.parentID]) {
          map[rec.parentID].children.push(map[rec.permissionRecordID])
        }
      })

      const sortChildren = (node) => {
        if (node.children && node.children.length > 0) {
          node.children.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
          node.children.forEach((child) => sortChildren(child))
        }
      }

      roots.sort((a, b) => (a.name || '').localeCompare(b.name || ''))
      roots.forEach((root) => sortChildren(root))

      return roots
    },
    flattenedRows() {
      const rows = []
      const flatten = (permission, level) => {
        rows.push({ permission, level })
        if (permission.children && permission.children.length) {
          permission.children.forEach((child) => {
            flatten(child, level + 1)
          })
        }
      }
      this.categories.forEach((root) => {
        flatten(root, 0)
      })
      return rows
    }
  },
  watch: {
    permissionRecords: {
      handler(newVal) {
        this.innerPermissionRecords = _cloneDeep(newVal || [])
      },
      immediate: true,
      deep: false
    }
  },
  created() {},
  methods: {
    handleToggle(permission, level) {
      const vm = this

      const hasChildren = permission.children && permission.children.length > 0
      const permissionId = permission.permissionRecordID
      const changedRecords = new Set([permissionId])

      function toggleChildren(node, isActive) {
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => {
            if (child.active !== isActive) {
              changedRecords.add(child.permissionRecordID)
              vm.$set(child, 'active', isActive)
              toggleChildren(child, isActive)
            }
          })
        }
      }

      if (hasChildren && !this.disableToggleChildren) {
        toggleChildren(permission, permission.active)
      }

      changedRecords.forEach((recordId) => {
        const innerRec = this.innerPermissionRecords.find((rec) => rec.permissionRecordID === recordId)
        const originalRec = this.permissionRecords.find((rec) => rec.permissionRecordID === recordId)
        if (innerRec && originalRec && originalRec.active !== innerRec.active) {
          this.$set(originalRec, 'active', innerRec.active)
        }
      })
    }
  }
}
</script>

<style scoped>
.access-parent-row {
  background: hsl(222, 77%, 95%);
  font-weight: bold;
}

.access-parent-row.theme-dark {
  background: hsl(222, 77%, 15%);
}
</style>